module.exports = __webpack_public_path__ + "img/figure-1.6b77ad6e.png";